import * as FormConst from "../constants/FormConst"
import SessionConst from "../constants/SessionConst"
import { getSessionItem, removeSessionItem, setSessionItem } from "./SessionHelper"

export const updateObject = (oldObject, updatedValues) => {
    return {
        ...oldObject,
        ...updatedValues
    }
}

export const isObjectEmpty = (inputObject) => {
    return inputObject === undefined || inputObject === "" || (Object.keys(inputObject).length === 0 && inputObject.constructor === Object)
}

export const searchObjectList = (searchElementKey, searchElementValue, objectList) => {
    if (!objectList) {
        return undefined
    }

    return objectList.filter(element => {
        if (element[searchElementKey] === searchElementValue) {
            return element
        }
    })
}

export const searchFirstObjectInList = (searchElementKey, searchElementValue, objectList) => {
    if (!objectList) {
        return undefined
    }

    let result = undefined
    let BreakException = {};

    try {
        objectList.forEach(element => {
            if (element[searchElementKey] === searchElementValue) {
                result = element
                throw BreakException
            }
        })
    } catch (e) {
        if (e !== BreakException) throw e;
    }
    return result
}

export const searchObjectListBoolean = (searchElementKey, searchElementValue, objectList) => {
    if (!isArrayNotEmpty(objectList)) {
        return false
    }

    let isFound = false
    let BreakException = {};

    try {
        objectList.forEach(element => {
            if (element[searchElementKey] === searchElementValue) {
                isFound = true
                throw BreakException
            }
        })
    } catch (e) {
        if (e !== BreakException) throw e;
    }
    return isFound
}

export const searchFirstIndexObjectList = (searchElementKey, searchElementValue, objectList) => {
    if (!isArrayNotEmpty(objectList)) {
        return -1
    }

    let index = -1
    let BreakException = {};

    try {
        objectList.forEach((element, elementIndex) => {
            if (element[searchElementKey] === searchElementValue) {
                index = elementIndex
                throw BreakException
            }
        })
    } catch (e) {
        if (e !== BreakException) throw e;
    }
    return index
}

export const updateObjectInList = (searchElementKey, searchElementValue, updateElementKey, updateElementValue, objectList) => {
    if (!objectList) {
        return
    }

    let isUpdated = false

    objectList.forEach(entry => {
        if (entry[searchElementKey] === searchElementValue) {
            entry[updateElementKey] = updateElementValue
            isUpdated = true
            return
        }
    })

    if (!isUpdated) {
        objectList.push({ [searchElementKey]: searchElementValue, [updateElementKey]: updateElementValue })
    }
}


export const excludeKeyFromObjectList = (searchElementKey, searchElementValue, objectList) => {
    if (!objectList) {
        return undefined
    }

    return objectList.filter(element => {
        if (element[searchElementKey] !== searchElementValue) {
            return element
        }
    })
}

export const findFirstPropertyInObjectWithValue = (value, object) => {
    if (isObjectEmpty(object)) {
        return undefined
    }
    let result
    Object.keys(object).forEach(key => {
        if (object[key] === value) {
            result = key
        }
    })
    return result
}

export const pad = (pad, str, padLeft) => {
    if (typeof str === 'undefined')
        return pad;
    if (padLeft) {
        return (pad + str).slice(-pad.length);
    } else {
        return (str + pad).substring(0, pad.length);
    }
}

export const isArrayNotEmpty = (array) => {
    return array && array.length > 0
}

export const sortObjectList = (objectList, sortProperty) => {
    if (!isArrayNotEmpty(objectList) || !sortProperty) {
        return objectList
    }

    return objectList.sort((a, b) => {
        if (a[sortProperty] < b[sortProperty]) {
            return -1
        } else if (a[sortProperty] > b[sortProperty]) {
            return 1
        } else {
            return 0
        }
    })
}


export const getCurrentDate = () => {
    var date = new Date()
    date.setHours(0, 0, 0, 0)
    return date
}

export const getDateOnly = (date) => {
    var result = new Date(date)
    result.setHours(0, 0, 0, 0)
    return result
}

export const getDateFromDateString = (dateStr) => {
    let dateString = dateStr + 'T00:00:00'
    return new Date(dateString)
}

export const getDateStringFromDate = (date) => {
    const year = date.getFullYear()
    let month = date.getMonth() + 1
    if (month < 10) {
        month = "0" + month
    }


    let day = date.getDate()
    if (day < 10) {
        day = "0" + day
    }
    return year + "-" + month + "-" + day
}

export const getCurrentDateString = () => {
    return getDateStringFromDate(getCurrentDate())
}

export const addYearsToDate = (date, inc) => {
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();
    return new Date(year + inc, month, day)
}

export const addDaysToDate = (date, days) => {
    if (!date) {
        return undefined
    }
    if (days === 0) {
        return date
    }
    let result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
}

export const subtractDaysFromDate = (date, days) => {
    if (!date) {
        return undefined
    }
    if (days === 0) {
        return date
    }
    let result = new Date(date)
    result.setDate(result.getDate() - days)
    return result
}

export const diffDaysBetweenDates = (date1, date2) => {
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays
}

/**
 * Excludes overlapping dates from date ranges to be excluded from a given date range.
 * @param {*} dateRange the master date range under consideration
 * @param {*} dateRangesToBeExcluded the date ranges to be excluded, non overlapping and within the provided master date range
 * @returns a list of date ranges
 */
export const excludeDateRangesFromDateRange = (dateRange, dateRangesToBeExcluded) => {
    let toExclude = sortObjectList(dateRangesToBeExcluded, 'startDate')

    let remainingDateRange = {
        startDate: getDateOnly(dateRange.startDate),
        endDate: getDateOnly(dateRange.endDate)
    }

    let output = []

    toExclude.forEach(exclude => {
        if (exclude.startDate.getTime() !== remainingDateRange.startDate.getTime()) {
            output.push({ startDate: remainingDateRange.startDate, endDate: subtractDaysFromDate(exclude.startDate, 1) })
        }
        remainingDateRange = {
            startDate: addDaysToDate(exclude.endDate, 1),
            endDate: remainingDateRange.endDate
        }
    })

    if (remainingDateRange.startDate.getTime() !== dateRange.endDate.getTime()) {
        output.push({ startDate: remainingDateRange.startDate, endDate: dateRange.endDate })
    }

    return output
}

export const isHotelDomestic = (hotelInfo) => {
    return hotelInfo?.address?.country === 'US'
}

export const isRadissonProperty = (brandCode) => {
    const radissonBrandCodes = ['CX', 'RA', 'RD', 'RB', 'PD', 'PK', 'RR', 'RV', 'RC']
    return radissonBrandCodes.includes(brandCode)
}
export const isManageRoomTypeBucketsEnabled = (brandCode, isHotelDomestic) => {
	const excludedRadissonBrandCodes = ['CX','PD']
    /** return false only for the domestic Radisson Brands that are in the excludedRadissonBrandCodes**/
	if (isHotelDomestic && excludedRadissonBrandCodes.includes(brandCode)){
	    return false
	}
	return true
}

export const isCompletedHotelInfoHistory = (hotelInfoCompletedHistory) => {
    return (hotelInfoCompletedHistory?.newEntity &&
            hotelInfoCompletedHistory?.newEntity?.status === "COMPLETED")
}

export const hideSrpInventoryPage = (hotelInfoCompletedHistory, checklist) => {
    const srpInventoryObject = searchFirstObjectInList('code', 'SRP_INVENTORY', checklist)
    return (srpInventoryObject === undefined && !!isCompletedHotelInfoHistory(hotelInfoCompletedHistory))
}

export const isFlagCompleted = (flagName, checklist) => {
    const sectionObject = searchFirstObjectInList('code', flagName, checklist)
    return (sectionObject?.processedFlag === 'COMPLETED')
}

export const getHotelCountry = (hotelInfo) => {
    return hotelInfo?.address?.country
}

export const getHotelCurrency = (hotelInfo) => {
    let hotelCurrency
    let hotelCurrencySymbol
    switch (getHotelCountry(hotelInfo)) {
        case 'US':
            hotelCurrency = 'USD'
            hotelCurrencySymbol = '$'
        case 'CN':
            hotelCurrency = 'CAD'
            hotelCurrencySymbol = 'C$'
        case 'AU':
            hotelCurrency = 'AUD'
            hotelCurrencySymbol = 'A$'
        case 'UK':
            hotelCurrency = 'GBP'
            hotelCurrencySymbol = '£'
        default:
            hotelCurrency = 'USD'
            hotelCurrencySymbol = '$'
    }
    return [hotelCurrency, hotelCurrencySymbol]
}

export const setHotelOnboardingStatusInSession = (onboardingStatus) => {
    setSessionItem(SessionConst.ONBOARDING_STATUS, onboardingStatus)
}

export const removeHotelOnboardingStatusFromSession = () => {
    removeSessionItem(SessionConst.ONBOARDING_STATUS)
}

export const setHotelInfoCompletedHistory = (hotelInfoCompletedHistory) => {
    setSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY, hotelInfoCompletedHistory)
}

export const setHotelInfoInSession = (hotelInfo, countryInfo) => {
    let isMetricSystem = !isHotelDomestic(hotelInfo)
    setSessionItem(SessionConst.HOTEL_CODE, hotelInfo.hotelCode)
    setSessionItem(SessionConst.HOTEL_INFO, hotelInfo)
    setSessionItem(SessionConst.IS_HOTEL_DOMESTIC, isHotelDomestic(hotelInfo) === false ? FormConst.VALUE_NO : FormConst.VALUE_YES)
    setSessionItem(SessionConst.IS_SCANDANAVIAN,
        isArrayIncludesAnySubstring(FormConst.SCANDANAVIAN_PROPERTY_TAGS, hotelInfo.groupingTags) === true ? FormConst.VALUE_YES : FormConst.VALUE_NO)
    setSessionItem(SessionConst.HOTEL_CURRENCY, hotelInfo.currencyCode)
    if (!isObjectEmpty(countryInfo)) {
        setSessionItem(SessionConst.MEASUREMENT_SYSTEM, isMetricSystem
            ? FormConst.VALUE_METRIC_MEASUREMENT_UNIT : FormConst.VALUE_STANDARD_MEASUREMENT_UNIT)
        setSessionItem(SessionConst.LENGTH_UNIT, isMetricSystem
            ? FormConst.VALUE_METRIC_LENGTH_UNIT : FormConst.VALUE_STANDARD_LENGTH_UNIT)
        setSessionItem(SessionConst.AREA_UNIT, isMetricSystem
            ? FormConst.VALUE_METRIC_AREA_UNIT : FormConst.VALUE_STANDARD_AREA_UNIT)
        setSessionItem(SessionConst.DISTANCE_UNIT, isMetricSystem
            ? FormConst.VALUE_METRIC_DISTANCE_UNIT : FormConst.VALUE_STANDARD_DISTANCE_UNIT)
        setSessionItem(SessionConst.DISTANCE_UNIT_LABEL, isMetricSystem
            ? FormConst.LABEL_METRIC_DISTANCE_UNIT : FormConst.LABEL_STANDARD_DISTANCE_UNIT)
        setSessionItem(SessionConst.WEIGHT_UNIT, isMetricSystem
            ? FormConst.VALUE_METRIC_WEIGHT_UNIT : FormConst.VALUE_STANDARD_WEIGHT_UNIT)
    }
}

export const removeHotelInfoFromSession = () => {
    removeSessionItem(SessionConst.HOTEL_CODE)
    removeSessionItem(SessionConst.HOTEL_INFO)
    removeSessionItem(SessionConst.IS_HOTEL_DOMESTIC)
    removeSessionItem(SessionConst.IS_SCANDANAVIAN)
    removeSessionItem(SessionConst.HOTEL_CURRENCY)
    removeSessionItem(SessionConst.MEASUREMENT_SYSTEM)
    removeSessionItem(SessionConst.LENGTH_UNIT)
    removeSessionItem(SessionConst.AREA_UNIT)
    removeSessionItem(SessionConst.DISTANCE_UNIT)
    removeSessionItem(SessionConst.DISTANCE_UNIT_LABEL)
    removeSessionItem(SessionConst.WEIGHT_UNIT)
    removeSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
}

export const isSubmitted = () => {
    return getSessionItem(SessionConst.IS_SUBMITTED) === FormConst.VALUE_YES
}

export const isReadOnly = () => {
    return getSessionItem(SessionConst.IS_READ_ONLY) === FormConst.VALUE_YES
}

export const setLockStatusInSession = (onboardingStatusResponse) => {
    let assignedUsername = onboardingStatusResponse.assignedTo
    let onboardingStatus = onboardingStatusResponse.status
    let currentUser = getSessionItem(SessionConst.USER)
    const currentUsername = currentUser.username
    const isReadOnlyUser = currentUser.isReadOnlyUser
    const isAdmin = currentUser.isAdmin
    let isApplicationReadOnly = true
    let isSubmitted = false

    if (FormConst.APPLICATION_SUBMITTED_STATUS_LIST.includes(onboardingStatus)) {
        isSubmitted = true
    }

    if (!isAdmin && FormConst.READ_ONLY_STATUS_LIST_NON_ADMINS.includes(onboardingStatus)) {
        // The application is read only anyway, don't acquire lock - read only Yes
        isApplicationReadOnly = true
    } else if (isAdmin && FormConst.READ_ONLY_STATUS_LIST_ADMINS.includes(onboardingStatus)) {
        isApplicationReadOnly = true
    } else if (!assignedUsername) {
        // If no user is assigned, then acquire the lock  - read only No
        assignedUsername = currentUsername
        isApplicationReadOnly = false
    } else if (assignedUsername === currentUsername) {
        // If the current user is the assigned user -  read only No
        isApplicationReadOnly = false
    } else {
        // If the current user is not the assigned user - read only Yes
        isApplicationReadOnly = true
    }
    setSessionItem(SessionConst.LOCK_OWNER, assignedUsername)
    setSessionItem(SessionConst.IS_SUBMITTED, isSubmitted ? FormConst.VALUE_YES : FormConst.VALUE_NO)
    setSessionItem(SessionConst.IS_READ_ONLY, isReadOnlyUser || isApplicationReadOnly ? FormConst.VALUE_YES : FormConst.VALUE_NO)
}

export const removeLockStatusFromSession = () => {
    removeSessionItem(SessionConst.IS_SUBMITTED)
    removeSessionItem(SessionConst.LOCK_OWNER)
    removeSessionItem(SessionConst.IS_READ_ONLY)
}

export const getTrackingId = (user) => {
    return user['firstname'] + '_' + user['family_name'] + '_' + new Date().getTime()
}

export const isArrayIncludesAny = (array1, array2) => {
    return isArrayNotEmpty(array1) && isArrayNotEmpty(array2) && array1.some(entry => array2.includes(entry))
}

export const isArrayExcludesAny = (array1, array2) => {
    return isArrayNotEmpty(array1) && isArrayNotEmpty(array2) && array1.some(entry => !array2.includes(entry))
}

/**
 * Checks if an array of strings includes any of the provided search strings as a substring in any entry
 * @param {Array} array1 array of strings to search for
 * @param {array} array2 array of strings to be searched
 * @returns if an array contains any of the provided search strings as a substring
 */
export const isArrayIncludesAnySubstring = (array1, array2) => {
    return isArrayNotEmpty(array1) && isArrayNotEmpty(array2)
        && array1.some(entry => array2.find(array2Entry => array2Entry && array2Entry.includes(entry)))
}

export const areObjectStringsEqual = (object1, object2) => {
    if (isObjectEmpty(object1) || isObjectEmpty(object2)) {
        return false
    }
    return JSON.stringify(object1) === JSON.stringify(object2)
}

export const groupBy = (objectArray, key) => {
    return objectArray.reduce(function (groupedResult, entry) {
        (groupedResult[entry[key]] = groupedResult[entry[key]] || []).push(entry);
        return groupedResult
    }, {})
}

export const dateRangeOverlaps = (dateRange1, dateRange2) => {
    if (!dateRange1 || !dateRange2 || !dateRange1.startDate || !dateRange1.endDate || !dateRange1.endDate || !dateRange2.endDate) {
        return false
    }
    if (dateRange1.startDate <= dateRange2.startDate && dateRange2.startDate <= dateRange1.endDate) return true // dateRange2 starts in dateRange1
    if (dateRange1.startDate <= dateRange2.endDate && dateRange2.endDate <= dateRange1.endDate) return true // dateRange2 ends in dateRange1
    if (dateRange2.startDate < dateRange1.startDate && dateRange1.endDate < dateRange2.endDate) return true // dateRange1 in dateRange2
    return false
}

export const multipleDateRangeOverlaps = (dateRanges) => {
    if (!isArrayNotEmpty(dateRanges) || dateRanges.length === 1) {
        // There should be more than one date range for comparison
        return []
    }

    let sortedDates = sortObjectList(dateRanges, 'startDate')

    for (let i = 0; i < sortedDates.length - 1; i++) {
        if (dateRangeOverlaps(sortedDates[i], sortedDates[i + 1])) {
            return [sortedDates[i], sortedDates[i + 1]]
        }
    }
    return []
}

export const getGapsInDateRanges = (dateRanges) => {

    if (!isArrayNotEmpty(dateRanges) || dateRanges.length === 1) {
        // There should be more than one date range for comparison
        return []
    }

    let sortedDates = sortObjectList(dateRanges, 'startDate')

    const gaps = []

    for (let i = 1; i < sortedDates.length; i++) {
        let endDateOfPreviousRange = sortedDates[i - 1].endDate
        let startDateOfCurrentRange = sortedDates[i].startDate

        if (addDaysToDate(endDateOfPreviousRange, 1) < startDateOfCurrentRange) {
            gaps.push({
                startDate: addDaysToDate(endDateOfPreviousRange, 1),
                endDate: subtractDaysFromDate(startDateOfCurrentRange, 1)
            })
        }
    }
    return gaps
}

export const sortObjectByKeys = (object) => {
    var key = Object.keys(object)
        .sort(function order(key1, key2) {
            if (key1 < key2) return -1
            else if (key1 > key2) return +1
            else return 0
        })

    // Taking the object in temp object and deleting the original object.
    var temp = {}

    for (var i = 0; i < key.length; i++) {
        temp[key[i]] = object[key[i]]
        delete object[key[i]]
    }

    // Copying the object from temp object to the original object.
    for (var i = 0; i < key.length; i++) {
        object[key[i]] = temp[key[i]]
    }
    return object
}

export const scrollToHtmlElementById = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' })
}